import { useCallback, useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import generateContactsTableColumns from "@components/ContactTable/generateContactsTableColumns";

import { useFetchContactEmailsQuery } from "@queries/contact.query";

import { useUserStore } from "@store/userStore";

interface IContactsTableConfig {
  rowMenuItems?: { func: (contactId: string) => void; label: string }[];
  workflow: string;
}

const useContactsTableConfig = ({ rowMenuItems, workflow }: IContactsTableConfig) => {
  const { role } = useUserStore();
  const { mutateAsync: fetchContactEmails } = useFetchContactEmailsQuery();
  const [fetchingEmails, setFetchingEmails] = useState<string[]>([]);

  const [searchParameters] = useSearchParams();
  const parameters = useParams();
  const technologyId = parameters.technologyId;

  const selectedCompaniesURL = searchParameters.getAll("companyIds[]");

  const selectedCompanyIds = useMemo(
    () => selectedCompaniesURL ?? [],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedCompaniesURL.length],
  );

  const fetchEmailForContact = useCallback(
    async (contactId: string) => {
      setFetchingEmails([...fetchingEmails, contactId]);
      await fetchContactEmails({
        companyIds: selectedCompanyIds,
        peopleIds: [contactId],
        technologyId: technologyId ?? "",
      });
      setFetchingEmails(fetchingEmails.filter((id) => id !== contactId));
    },
    [fetchContactEmails, fetchingEmails, technologyId, selectedCompanyIds],
  );

  const columns = generateContactsTableColumns({
    fetchEmailForContact,
    fetchingEmails,
    role: role || "",
    rowMenuItems,
    workflow,
  });

  return {
    columns,
  };
};

export default useContactsTableConfig;
